module.exports = __webpack_public_path__ + "img/404-error.e90d1a22.png";